import { change } from 'redux-form';

import { ITEM_LISTING_FORM_NAME } from 'Common/FormEnum';
import { PrintBarcodeEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { loading, handleErrorException, success } from 'State/actions';

import * as types from './types';

export const getItemList = flag => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `/Barcodes/GetInventoryItemsForPrint/${flag}`
      );
      dispatch(
        success(
          types.ITEM_LIST_DATA,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again.',
      };
      dispatch(
        handleErrorException(err, types.ITEM_DATA_LIST_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.ITEM_DATA_LOADING, false));
    }
  };
};

export const printBarcodeData = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_BARCODE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        '/Barcodes/GetInventoryItemsBarcode',
        requestObj
      );
      if (response.data.Data) {
        dispatch(success(types.PRINT_BARCODE_DATA, response.data.Data));
      } else {
        dispatch({
          type: types.SET_PRINT_RESPONSE_EMPTY,
        });
      }
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while printing barcodes. Please try again.',
      };
      dispatch(
        handleErrorException(err, types.PRINT_BARCODE_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_BARCODE_LOADING, false));
    }
  };
};

export const clearPrintBarcodeError = () => {
  return {
    type: types.CLEAR_PRINT_ERROR,
  };
};

export const setItemsIds = values => {
  return change(ITEM_LISTING_FORM_NAME, PrintBarcodeEnum.ItemListInfo, values);
};

export const setFilteredItemListData = data => {
  return {
    type: types.ITEM_LIST_DATA,
    payload: data,
  };
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/printBarcodes/action.js